
import Vue from 'vue'
import Vuex from 'vuex'

import archives from './archives'
import articles from './articles'
import bordereauxLivraison from './bordereauxLivraison'
import budgets from './budgets'
import catalog from './catalog'
import clients from './clients'
import commandes from './commandes'
import devis from './devis'
import echeanciers from './echeanciers'
import factures from './factures'
import habilitations from './habilitations'
import listes from './listes'
import modesLivraison from './modesLivraison'
import settings from './settings'
import sites from './sites'
import utilisateurs from './utilisateurs'

const DEBUG = process.env.NODE_ENV !== 'production'

let Store = (() => {

  Vue.use(Vuex)

  const STORE = new Vuex.Store({
    modules: {
      archives,
      articles,
      bordereauxLivraison,
      budgets,
      catalog,
      clients,
      commandes,
      devis,
      echeanciers,
      factures,
      habilitations,
      listes,
      modesLivraison,
      settings,
      sites,
      utilisateurs
    },
    strict: DEBUG
  })  

  console.log('📚 Store Adelya initialisé')
  return STORE
  
})()

export default Store